import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import HomeContent from '../apps/Home/components/HomeContent';
import Content from '../components/mplat/Content';
import { ErrorModal } from '../components/mplat/Modals/ErrorModal';
import { useLanguage } from '../hooks';

function HomePage() {
    const lang = useLanguage();
    const [lockModal, setLockModal] = useState(false);

    useEffect(() => {
        document.title = t('cms:INDEX_TITLE');
    }, [t, lang]);

    return (
        <>
            <div className="welcome-home__back">
                <div className="welcome-home__back-inner">
                    {[...Array(6)].map((_, i) => (
                        <div key={i} className="welcome-home__back-item"></div>
                    ))}
                </div>
            </div>
            {lockModal && <ErrorModal
                title={<Trans i18nKey={'component:LOCK_TITLE'} />}
                content={<Trans i18nKey={'component:LOCK_BODY'}>Link to <a href="mailto:managers@mediabaza.ru"></a> for help</Trans>}
                isOpen={lockModal}
                onClose={() => setLockModal(false)}
            />}

            <Content withoutInner>
                <HomeContent />
            </Content>
        </>
    )
}

export default HomePage;